define(['text!./templates/Badge.html'], template => angular.module('edge.platform.widgets.badge', []).directive('gwBadge', [() => ({
    restrict: 'E',
    transclude: true,
    replace: true,
    template: template,
    scope: {
        type: '@'
    }
})]));


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/badge/module.js